export default __webpack_public_path__ + "static/media/cross.6417ed40.svg";